export const GET_REQUEST_ACCRUAL_TEMPLATES_BEGIN = 'GET_REQUEST_ACCRUAL_TEMPLATES_BEGIN'
export const GET_REQUEST_ACCRUAL_TEMPLATES_SUCCESS = 'GET_REQUEST_ACCRUAL_TEMPLATES_SUCCESS'
export const GET_REQUEST_ACCRUAL_TEMPLATES_ERROR = 'GET_REQUEST_ACCRUAL_TEMPLATES_ERROR'